import React from 'react'
import KamronHeader from './KamronHeader'
import {KamronSingle} from './KamronSingle'

const Qamchiyev = ({open}) => {
  return (
    <div>
        <KamronHeader/>
        <KamronSingle open={open}/>
    </div>
  )
}

export default Qamchiyev